import React from "react";
import classnames from "classnames";

import "./Counter.scss";

export function Counter(props) {
  const { className, amount, limit, label } = props;

  return (
    <div data-testid={"counter"} className={classnames("counter", className)}>
      <div className={"counter__label"}>{label}</div>
      <span className={classnames("counter__amount", `${className}__amount`)}>
        (<span>{amount}</span>/<span>{limit}</span>)
      </span>
    </div>
  );
}
